import styles from "./ProgressBar.module.css"

const ProgressBar = ({ progress }) => {

    return(
    <div className={styles.progressLoader}>
        <div className={styles.progress} style={{width: `${progress}%`}}></div>
    </div>
    )

}

export default ProgressBar